// Modules
import React from 'react';
import { CellProps } from 'react-table';

// Types
import { IBasstrakkAngler } from '../../types';

// Component
import ActivityCatchCell from '../../blocks/BasstrakkTable/ActivityCatchCell';
import NoActivity from '../../components/Column/NoActivity';

// Util
// import { formatTime } from '../../util/util';

// Config
import AnglerCell from '../../components/Column/AnglerCell';
import { CLASS_PREFIX, NO_CATCHES_TEXT } from '../../config';
/**
 * AOY columns
 */
export const AoyColumns = [
  {
    Header: '',
    id: 'hidden',
    columns: [
      {
        Header: 'Rank',
        accessor: 'AoyStanding.AOYRank',
        id: 'aoyRank',
        className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell--700 ${CLASS_PREFIX}cell__rank`,
        headerClassName: `${CLASS_PREFIX}header__rank`,
        width: 35,
        align: 'center',
      },
      {
        Header: 'Angler', // ▶
        id: 'angler', // Must have an id
        accessor: 'FISHERMAN_PHONENAME',
        className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell--700 ${CLASS_PREFIX}cell__angler`,
        headerClassName: `${CLASS_PREFIX}header__angler`,
        width: 125,
        minWidth: 115,
        maxWidth: 200,
        Cell: ({ row, index, width }: CellProps<IBasstrakkAngler>) => (
          <AnglerCell
            anglerName={row.values.angler}
            isLeader={
              row.original.FISHERMENID === row.original.BigBassLeader.AnglerId
            }
            index={index}
            isExpanded={row.isExpanded}
            width={width}
          />
        ),
      },
      {
        Header: 'PTS',
        id: 'aoyPts',
        accessor: 'AoyStanding.PointsTotal',
        className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell--700`,
        headerClassName: `${CLASS_PREFIX}header__pts`,
        minWidth: 175,
      },
      {
        Header: 'PTS this Tournament',
        accessor: 'AoyStanding.PointsEarned',
        className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell--700`,
        headerClassName: `${CLASS_PREFIX}header__pts`,
        minWidth: 175,
      },
      {
        Header: 'Activity',
        // We want this column to still be sortable so we will use the weight
        // (string) as the accessor value
        accessor: originalRow => {
          const lastCatch = originalRow.Catches.slice(-1)[0];
          // If an angler doesn't have any catches just say so
          if (!lastCatch) {
            return 'No Activity';
          }
          // By returning the weight as the value for the accessor this allows
          // this column to be sorted by that weight and not by what's returned in
          // the "Cell" below. There would be no need to sort
          // since all the columns would start with (New Catch...)
          return lastCatch.FishWeightPdsOz;
        },
        className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell__activity`,
        headerClassName: `${CLASS_PREFIX}header__activity`,
        minWidth: 175,
        Cell: ({ value, row }) => {
          if (value !== NO_CATCHES_TEXT) {
            const lastCatch = row.original.Catches.slice(-1)[0];
            return (
              <ActivityCatchCell
                key={row.original.FISHERMAN_PHONENAME}
                row={row}
                lastCatch={lastCatch}
              />
            );
          }
          return <NoActivity classPrefix={CLASS_PREFIX} />;
        },
      },
    ],
  },
];
